import React, { Context } from 'react'
const LocalesContext: Context<localesInterface> = React.createContext(
  {} as localesInterface
)
export const LocalesProvider = LocalesContext.Provider
export default LocalesContext
